<template>
  <option :value="value"><slot>{{ label }}</slot></option>
</template>

<script setup lang="ts">
defineProps<{
  label?: string | number;
  value?: string | number;
}>();
</script>
